import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// components
import SherpaLogo from "assets/images/blueBlackSherpaLogo.svg";
import LoginBg from "assets/images/loginBG.png";
var AuthPagesWrapper = function (_a) {
    var children = _a.children;
    return (_jsxs("section", { className: "flex w-full h-screen", children: [_jsx("div", { className: "bg-white w-full h-full flex relative", children: _jsxs("div", { className: "w-10/12 my-auto mx-auto", children: [_jsx("img", { src: SherpaLogo, alt: "Sherpa Logo", className: "my-4 w-[200px]" }), children] }) }), _jsx("div", { className: "w-full hidden md:flex", children: _jsx("img", { src: LoginBg, alt: "houses image", className: "w-full object-cover" }) })] }));
};
export default AuthPagesWrapper;
